import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TextHidingModule} from '../../directives/text-hiding';
import {DropdownMenuModule} from '../dropdown-menu';
import {OverlayModule} from '../overlay';
import {ScrollbarWithEndingBlindsModule} from '../scrollbar-with-ending-blinds';
import {TooltipModule} from '../tooltip';
import {L10nModule} from '../translate';
import {SelectInputMenuComponent} from './select-input-menu';
import {SelectInputComponent} from './select-input.component';
import {SelectInputService} from './select-input.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        OverlayModule,
        DropdownMenuModule,
        TextHidingModule,
        TooltipModule,
        ScrollbarWithEndingBlindsModule
    ],
    declarations: [
        SelectInputComponent,
        SelectInputMenuComponent
    ],
    exports: [
        SelectInputComponent
    ],
    providers: [
        SelectInputService
    ]
})
export class SelectInputModule {}
